"use client";

import React from "react";
import LayoutDashboard from "@/components/Dashboard";
import { Button, ConfigProvider, Result } from "antd";
import styled from "@emotion/styled";
import Link from "next/link";

const Content = styled(Result)`
  :where(.css-dev-only-do-not-override-pr0fja).ant-result {
    padding: 48px 32px;
  }
`;

const NotFoundPage: React.FC = () => {
  return (

    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Content
        status="404"
        title="404"
        subTitle="La página que buscas no existe o no está disponible en este momento"
        extra={
          <Link href={"/"}>
            <Button type="primary">Volver al inicio</Button>
          </Link>
        }
      />
    </div>

  );
};

export default NotFoundPage;
